module.exports = __webpack_public_path__ + "static/018.thumb-f7802b7b019844ddc5735d549e9fb8b1.jpg";